import { ApiSlugs, UserRegistrationDto, UserRegistrationId } from '@workspace/data-types';
import { ApiCaller } from '../../../../api-caller.service';
import { ApiConnector } from '../../../../api-connector.abstract-service';
import { UserRegistrationEmailsAdminConnector } from './emails/user-registration-emails.connector';
import { UserRegistrationSMSAdminConnector } from './sms/user-registration-sms.connector';
import { UserRegistrationTokenVaultsAdminConnector } from './token-vaults/user-registration-token-vaults.connector';

export class UserRegistrationAdminConnector extends ApiConnector<
  UserRegistrationDto,
  UserRegistrationDto,
  UserRegistrationId
> {
  constructor(apiCaller: ApiCaller, userRegistrationId: UserRegistrationId, apiPrefix: string) {
    super(apiCaller, apiPrefix, `${ApiSlugs.USER_REGISTRATION}/${userRegistrationId}`);
  }

  emails = () => new UserRegistrationEmailsAdminConnector(this.apiCaller, this.slug, this.apiPrefix);
  sms = () => new UserRegistrationSMSAdminConnector(this.apiCaller, this.slug, this.apiPrefix);
  tokenVaults = () =>
    new UserRegistrationTokenVaultsAdminConnector(this.apiCaller, this.slug, this.apiPrefix);
}
